import api from '../api';

// --- Rapporti bancari ---
export const getRapporti = (scope) => api.get('/conti/rapporti', { params: { scope } }).then((r) => r.data);
export const creaRapporto = (dati) => api.post('/conti/rapporti', dati).then((r) => r.data);
export const modificaRapporto = (id, dati) => api.put(`/conti/rapporti/${id}`, dati).then((r) => r.data);

// --- Piano dei conti ---
export const getPiano = (scope, soloAttive = false) =>
  api.get('/conti/piano', { params: { scope, solo_attive: soloAttive } }).then((r) => r.data.voci);
export const creaVoce = (dati) => api.post('/conti/piano', dati).then((r) => r.data);
export const modificaVoce = (id, dati) => api.put(`/conti/piano/${id}`, dati).then((r) => r.data);
export const importaVociDaFirefly = (scope) =>
  api.post('/conti/piano/importa-da-firefly', null, { params: { scope } }).then((r) => r.data);

// --- Movimenti ---
export const getMovimenti = (params) => api.get('/conti/movimenti', { params }).then((r) => r.data);
export const getContoMovimenti = () => api.get('/conti/movimenti/count').then((r) => r.data);
export const getSuggerimentiDescrizioni = (scope) => api.get('/conti/movimenti/suggerimenti', { params: { scope } }).then((r) => r.data);
export const creaMovimento = (dati) => api.post('/conti/movimenti', dati).then((r) => r.data);
export const modificaMovimento = (id, dati) => api.put(`/conti/movimenti/${id}`, dati).then((r) => r.data);
export const getContoTraSoci = () => api.get('/conti/soci/tra-loro').then((r) => r.data);
export const getDivisione = (id) => api.get(`/conti/movimenti/${id}/divisione`).then((r) => r.data);
export const dividiMovimento = (id, parti) => api.post(`/conti/movimenti/${id}/dividi`, { parti }).then((r) => r.data);
export const riapriMovimento = (id) => api.post(`/conti/movimenti/${id}/riapri`).then((r) => r.data);
export const riapriMovimenti = (ids) => api.post('/conti/movimenti/riapri-multipli', { ids }).then((r) => r.data);
export const ignoraIncassiOrdini = () => api.post('/conti/movimenti/ignora-incassi-ordini').then((r) => r.data);
export const segnaRiservati = (ids, riservato) => api.post('/conti/movimenti/riservati', { ids, riservato }).then((r) => r.data);
export const eliminaMovimento = (id) => api.delete(`/conti/movimenti/${id}`).then((r) => r.data);
export const classificaMovimento = (id, dati) => api.post(`/conti/movimenti/${id}/classifica`, dati).then((r) => r.data);
export const convertiMovimentiMultipli = (dati) => api.post('/conti/movimenti/converti-multipli', dati).then((r) => r.data);
export const convertiMovimento = (id, dati) => api.post(`/conti/movimenti/${id}/converti`, dati).then((r) => r.data);
export const classificaMovimentiMultipli = (dati) => api.post('/conti/movimenti/classifica-multipli', dati).then((r) => r.data);
export const registraMovimento = (id) => api.post(`/conti/movimenti/${id}/registra`).then((r) => r.data);
export const registraMovimenti = (ids) => api.post('/conti/movimenti/registra-multipli', { ids }).then((r) => r.data);
export const ignoraMovimenti = (ids) => api.post('/conti/movimenti/ignora-multipli', { ids }).then((r) => r.data);
export const getFormatiImport = () => api.get('/conti/formati-import').then((r) => r.data.formati);
export const importaMovimenti = ({ bancaId, fonte, file, conferma, ignora = [], includi = [] }) => {
  const dati = new FormData();
  dati.append('banca_id', bancaId);
  dati.append('fonte', fonte);
  dati.append('conferma', conferma ? 'true' : 'false');
  dati.append('ignora', JSON.stringify(ignora));
  dati.append('includi', JSON.stringify(includi));
  dati.append('file', file);
  return api.post('/conti/movimenti/importa', dati, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};

export const getSaldiSoci = () => api.get('/conti/soci/saldi').then((r) => r.data);

// --- Finanziamenti ---
export const getFinanziamenti = (scope) => api.get('/conti/finanziamenti', { params: { scope } }).then((r) => r.data);
export const creaFinanziamento = (dati) => api.post('/conti/finanziamenti', dati).then((r) => r.data);
export const modificaFinanziamento = (id, dati) => api.put(`/conti/finanziamenti/${id}`, dati).then((r) => r.data);
export const importaFinanziamenti = (scope) => api.post('/conti/finanziamenti/importa-da-firefly', null, { params: { scope } }).then((r) => r.data);
export const impostaResiduo = (id, dati) => api.post(`/conti/finanziamenti/${id}/residuo`, dati).then((r) => r.data);
export const registraRata = (id, dati) => api.post(`/conti/finanziamenti/${id}/rata`, dati).then((r) => r.data);
export const getRateFinanziamento = (id) => api.get(`/conti/finanziamenti/${id}/rate`).then((r) => r.data.rate);

// --- Bilancio ---
export const getBilancio = (scope, da, a) => api.get('/conti/bilancio', { params: { scope, da, a } }).then((r) => r.data);

// Messaggio leggibile dagli errori del backend
export const messaggioErrore = (e, predefinito = 'Operazione non riuscita') =>
  e?.response?.data?.detail && typeof e.response.data.detail === 'string' ? e.response.data.detail : predefinito;
